import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "./ApiRequest";
import { ProductFlow } from "./EndPoints";

export const GetProductsAPI = (
  sectionId = "",
  currentPage = "",
  pageSize = "",
  query = "",
  filter = "",
  cat_id = "",
  sub_cat_id = ""
) => {
  return getRequest(
    `${ProductFlow.PRODUCTS_SECTION}/${sectionId}/products?page=${currentPage}&per_page=${pageSize}&category=${cat_id}&subCategory=${sub_cat_id}&query=${query}&filter=${filter}`
  );
};
export const GetSingleProductAPI = (sectionId, productId, data_format = "") => {
  let url = `${ProductFlow.PRODUCTS_SECTION}/${sectionId}/products/${productId}`;

  if (data_format) {
    url += `?data_format=${data_format}`;
  }

  return getRequest(url);
};

export const CreateProductAPI = (id, payload) => {
  return postRequest(`${ProductFlow.PRODUCTS_SECTION}/${id}/products`, payload);
};
export const UpdateProductAPI = (id, productId, payload) => {
  return patchRequest(
    `${ProductFlow.PRODUCTS_SECTION}/${id}/products/${productId}`,
    payload
  );
};
export const DeletedProductAPI = (id, productId) => {
  return deleteRequest(
    `${ProductFlow.PRODUCTS_SECTION}/${id}/products/${productId}`
  );
};

export const GetAttributesFilterOptionsAPI = (
  currentPage = "",
  pageSize = "",
  codId
) => {
  return getRequest(
    `${ProductFlow.PRODUCTS_ATTRIBUTE}?page=${currentPage}&per_page=${pageSize}&query=${codId}`
  );
};
export const GetAttributeAPI = (id) => {
  return getRequest(`${ProductFlow.PRODUCTS_ATTRIBUTE}/${id}`);
};
export const CreateAttributeAPI = (sectionId, id, payload) => {
  return postRequest(
    `${ProductFlow.PRODUCTS_SECTION}/${sectionId}/products/${id}/attributes`,
    payload
  );
};
export const UpdateAttributeAPI = (sectionId, id, payload) => {
  return patchRequest(
    `${ProductFlow.PRODUCTS_SECTION}/${sectionId}/products/${id}/attributes`,
    payload
  );
};

export const AssignProductsSubCategory = (sectionId, payload) => {
  return postRequest(
    `${ProductFlow.PRODUCTS_SECTION}/${sectionId}/products/assign`,
    payload
  );
};
